// Packages and components
import React from 'react';
import { FormField, Select } from 'grommet';

// Helpers and utlities

// Types
import type { SHDSelectProps } from './SHDSelect.d';

const SHDSelect: React.FC<SHDSelectProps> = ({
  className = 'select',
  error = null,
  label,
  onChange,
  options,
  value,
}) => {
  return (
    <div className={`${className} full-width`}>
      <FormField
        className={`${className}__label`}
        label={label}
        error={error?.message}
      >
        <Select
          className={`${className}__select`}
          labelKey="label"
          onChange={({ option }) => onChange(option)}
          options={options}
          value={value?.value}
          valueKey={{ key: 'value', reduce: true }}
        />
      </FormField>
    </div>
  );
};

export default SHDSelect;
